import React, {useState, useEffect} from 'react'
import './Checkout.css';
import Subtotal from './Subtotal';
import { initializeApp } from 'firebase/app';
import {firebaseConfig} from './firebaseAuth';
import { useStateValue } from './StateProvider';
import CheckoutProduct from './CheckoutProduct';
import {onAuthStateChanged, getAuth} from "firebase/auth";


const app = initializeApp(firebaseConfig);
const auth=getAuth(app);


function Checkout() {
  const [{ basket}]= useStateValue();

  const [user , setUser]= useState(null);
  useEffect(() => {
    onAuthStateChanged(auth, user=>{
      if(user){
        // yes you are logged in
        setUser(user)
      } else{
        // user is logged out
        console.log('you are logged out')
        setUser(null);
      }
    })
  },[])

  if(user === (null)){
  return (
    <div className="checkout">
        <div className="checkout__left">
            <img className="checkout__ad" src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg" alt="" />
             <div>
              <h3>Hello</h3>
            <h2 className="checkout__title">
                Your shopping Basket
            </h2>
            {basket.map(item =>(
              <CheckoutProduct
                     id={item.id}
                     title= {item.title}
                     image= {item.image}
                     price= {item.price}
                     rating= {item.rating}
              />
            ))}


            {/* <CheckoutProduct/> */}
            {/* <CheckoutProduct/> */}
            {/* <CheckoutProduct/> */}
            {/* <CheckoutProduct/> */}
            {/* <CheckoutProduct/> */}
            </div>
        </div>
        <div className="checkout__right">
          <Subtotal />
            
        </div>
    </div>
  )
   }
   return (
    <div className="checkout">
        <div className="checkout__left">
            <img className="checkout__ad" src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg" alt="" />
             <div>
            <h3>Hello, {user.email}</h3>
            <h2 className="checkout__title">
                Your shopping Basket
            </h2>
            {basket.map(item =>(
              <CheckoutProduct
                     id={item.id}
                     title= {item.title}
                     image= {item.image}
                     price= {item.price}
                     rating= {item.rating}
              />
            ))}


            {/* <CheckoutProduct/> */}
            {/* <CheckoutProduct/> */}
            {/* <CheckoutProduct/> */}
            {/* <CheckoutProduct/> */}
            {/* <CheckoutProduct/> */}
            </div>
        </div>
        <div className="checkout__right">
          <Subtotal />
            
        </div>
    </div>
  )
}

export default Checkout